export type FreshSession = {
	accessToken?: string;
	error?: 'RefreshAccessTokenError';
} | null;

/**
 * Produces an access-token getter that always asks the auth session endpoint for
 * current state. Concurrent API calls share one request, which prevents refresh
 * token rotation races when a page loads several protected resources together.
 */
export function createFreshAccessTokenGetter(fetchSession: () => Promise<FreshSession>) {
	let inFlight: Promise<FreshSession> | null = null;

	return async (): Promise<string | null> => {
		inFlight ??= fetchSession().finally(() => {
			inFlight = null;
		});
		const session = await inFlight;
		return session?.error ? null : (session?.accessToken ?? null);
	};
}
